import { useState } from 'react';
import { useAsyncData } from 'shared/hooks/useAsyncData';
import { MuralPost } from 'modules/jogador/mural/types';
import { NewRachaForm } from 'modules/jogador/mural/components/CreateRachaCard';
import { useAuth } from 'shared/hooks/useAuth';
import { fetchMuralPosts, joinMuralPost, publishRacha } from 'modules/jogador/mural/muralService';

const EMPTY_FORM: NewRachaForm = {
  sport: 'Beach Tennis',
  location: '',
  when: '',
  level: 'Intermediário',
  spots: 4,
  notes: '',
};

export function useMural() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('rachas');
  const { data: posts, isLoading, error, setData: setPosts } = useAsyncData<MuralPost[]>(fetchMuralPosts, []);
  const [joinedPostIds, setJoinedPostIds] = useState<string[]>([]);
  const [isCreatingRacha, setIsCreatingRacha] = useState(false);
  const [rachaForm, setRachaForm] = useState<NewRachaForm>(EMPTY_FORM);

  function joinPost(postId: string) {
    setJoinedPostIds((prev) => (prev.includes(postId) ? prev : [...prev, postId]));
    joinMuralPost(postId).catch(() => {});
  }

  function updateRachaForm(patch: Partial<NewRachaForm>) {
    setRachaForm((prev) => ({ ...prev, ...patch }));
  }

  function openCreateRacha() {
    setRachaForm(EMPTY_FORM);
    setIsCreatingRacha(true);
  }

  function cancelCreateRacha() {
    setIsCreatingRacha(false);
  }

  async function publishRachaPost() {
    if (!rachaForm.location.trim() || !rachaForm.when.trim()) return;

    const newPost = await publishRacha({ ...rachaForm, authorName: user?.name ?? 'Você' });
    setPosts((prev) => [newPost, ...prev]);
    setJoinedPostIds((prev) => [...prev, newPost.id]);
    setIsCreatingRacha(false);
  }

  return {
    activeTab,
    setActiveTab,
    posts,
    isLoading,
    error,
    joinedPostIds,
    joinPost,
    isCreatingRacha,
    rachaForm,
    updateRachaForm,
    openCreateRacha,
    cancelCreateRacha,
    publishRacha: publishRachaPost,
  };
}
